import {
  bimFileApi,
  forgeApi,
  generatedDataApi,
  projectApi,
  userApi,
} from "apiClient/v2";
import { DataProjectModel } from "interfaces/models/dataProjectModel";
import { DataGenerate } from "interfaces/models/generateData";

export const cacheDefaultData = async () => {
  await Promise.all([
    userApi.handleGetProfile(true),
    forgeApi.getProjects(false, true),
    projectApi.getProjectList({ shouldCache: true }),
    bimFileApi.getProjectList({ shouldCache: true }),
  ]);
};

export const checkProjectGenerated = async (
  project: DataProjectModel,
  shouldCache?: boolean
): Promise<{ isGenerated: boolean; dataGenerate: DataGenerate | null }> => {
  const result = { isGenerated: false, dataGenerate: null };
  try {
    const urn = `${project.id}?version=${project.version}`;
    const response = await generatedDataApi.checkGeneratedData({
      urn,
      projectId: project.projectId,
      shouldCache,
    });
    if (!response?.dataGenerate) {
      return result;
    }

    return response;
  } catch (err) {
    return result;
  }
};
